export default __webpack_public_path__ + "static/media/search_white.e1ddc1a4.svg";